import { useState } from 'react';

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Textarea,
} from '@/components/TailwindComponents';
import { IFile } from '@/models';

export const DeleteFileModal = ({
  isModalOpen,
  file,
  onCancel,
  onConfirm,
}: {
  isModalOpen: boolean;
  file?: IFile;
  onCancel: () => void;
  onConfirm: (reason: string, file?: IFile) => void;
}) => {
  const [reason, setReason] = useState('');

  return (
    <Dialog open={isModalOpen} onOpenChange={(isOpen) => !isOpen && onCancel()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>
            Are you sure you want to delete the file{' '}
            <span
              className="truncate max-w-[200px] inline-block align-bottom overflow-hidden"
              title={file?.name}
            >
              {file?.name}
            </span>
          </DialogTitle>
          <DialogDescription>
            Add reason for deleting the file (required)
          </DialogDescription>
        </DialogHeader>
        <div className="py-4">
          <Textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Enter reason for deletion..."
            className="w-full resize-none"
            rows={4}
          />
        </div>
        <DialogFooter className="justify-end">
          <button
            onClick={onCancel}
            className="mt-2 sm:mt-0 px-4 py-2 border border-gray-300 rounded-md text-sm font-medium bg-white text-gray-700 hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            onClick={() => onConfirm(reason, file)}
            disabled={!reason.trim()}
            className={`px-4 py-2 rounded-md text-sm font-medium ${
              reason.trim()
                ? 'bg-red-600 text-white hover:bg-red-700'
                : 'bg-red-300 text-white cursor-not-allowed'
            }`}
          >
            Delete File
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
